"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var SecondPlace = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.secondPlaceContainer },
        react_1.default.createElement("img", { src: "/img/tournaments/secondPlace.svg", alt: "second", style: { marginBottom: '-35px' } })));
};
exports.default = SecondPlace;
